export default {
  title: 'Configure your video academy',
  description:
    'You can configure videos and learning paths that needs to shown in the video academy along with analytics, public/private access, theme and text copy. ',
  disabled_description:
    'Video academy enables you to host your videos and learning paths in a separate space and make it accessible to your users. You can also control the access on who can view this video academy.',
  enable_hub_contact: `Video academy is available only in the Enterprise plan. Kindly <a href="mailto:support@trainn.co"> contact us </a> to know more about this.`,
  button: {
    disable: 'Disable Academy',
    enable: 'Enable Academy',
    email_activity: 'Email user activity'
  },
  tab: {
    settings: 'Settings',
    analytics: 'Analytics',
    custom_domain: 'Custom Domain',
    theme: 'Theme',
    copy: 'Copy',
    content: 'Content'
  },
  auth_type: {
    label: 'Authentication',
    desc: 'Configure authentication settings for your video academy.',
    public: 'Public Access',
    public_desc:
      'No authentication required. Anyone can access the video academy',
    private: 'Private Access',
    private_desc: 'Only authenticated customers can access the video academy',
    sso: "Use your application's authentication (SSO)",
    sso_documentation_link:
      "Check this <a target='_blank' href='https://www.notion.so/Trainn-Hub-Single-sign-on-Integration-9785fc4351b540d9a5fb4e3da4f5fcc3'>documentation</a> on how to integrate SSO with video academy.",
    sso_desc:
      'Allows members to sign in to your video academy using your application authentication',
    train_login: "Use Trainn's Authentication",
    train_login_desc:
      "Allows members to sign in to your video academy using Trainn's authentication",
    train_auth_customer_signup: 'Allow anyone to sign up',
    train_auth_customer_signup_desc:
      'Uncheck to restrict the access only to existing customers',
    login_url: 'Login URL',
    login_url_desc:
      'URL to which the user needs to be redirected for authentication.'
  },
  general_settings: 'General Settings',
  goto_url: 'Goto url for your application',
  allow_crawling: 'Allow google to crawl all the videos',
  private_crawling: 'Allow google to crawl login page',
  analytics: {
    allow_ga_label: 'Enable Google Analytics',
    allow_ga_desc:
      'Use Google Analytics to ee how respondents find and interact with your academy.',
    tracking_code_label: 'Google Analytics tracking code',
    tracking_code_desc: 'Copy and paste your Google Analytics tracking code',
    cross_origin_tracking_label: 'Enable cross origin tracking',
    origin_ids_label: 'Origin Ids',
    origin_ids_desc: 'Use comma to separate domain names'
  },
  theme: {
    primary_color: 'Primary Color',
    placeholder: '#FFFFFF',
    favicon: 'Upload your favicon',
    faviconDescription: 'Recommended size is 32 x 32 pixels',
    bannerImage: 'Upload your banner image',
    bannerDescription:
      "Recommended size is 1440 x 780 pixels. You can download banner images for free from <a href='https://unsplash.com/' target='_blank'>Unsplash.</a>"
  },
  copy: {
    title: 'Video academy title',
    title_placeholder: `{workspace_name} Video Academy`,
    description: 'Video academy description',
    login_description: 'Video academy login description',
    desc_placeholder:
      'A description of your workspace. Example, One stop knowledge academy to learn everything about {workspace_name}',
    login_desc_placeholder:
      "We have created videos for you on how to use our product. Login to view these videos and understand our product's capabilities."
  },
  content: {
    collection_title: 'Learning Paths',
    collection_desc:
      'Add the learning paths that needs to be displayed in your video academy',
    recommended_title: 'Recommended Videos',
    recommended_desc:
      'Videos added here will be displayed in the Recommended videos section',
    add_collection: 'Add Learning Path',
    available_collections: 'Available learning paths',
    add_videos: 'Add Recommended Videos',
    availabe_videos: 'Available Videos'
  },
  invalid_url_format: 'Please enter a valid url',
  portal_url: 'Your portal url',
  trigger_email_activity: 'User activity will be sent to your mail'
};
